<template>
  <div v-if="!is_toggled" id="switch-btn">
    <a :href="creatorUrl">
      <div>
        <img
            height="14"
            width="20"
            :src="youtubeIcon"
            alt="youtube"
        />
        <span :style="{ color: hasYoutubeChannel ? '#0e0525' : '#0E0525' }">Creator</span>
      </div>
    </a>
    <a :href="artistOrLabelUrl" class="active">
      <div>
        <img
            height="21"
            width="21"
            :src="imageUrl"
            alt="artist"
        />
        {{ userLevelName }}
      </div>
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SwitchButtons',
  props: {
    userLevelName: {
      required: true,
      type: String
    }
  },
  computed: {
    ...mapState('auth', ['user', 'is_toggled']),

    imageUrl() {
      let imgName = ''

      if (this.userLevelName.toLowerCase() === 'artist') imgName = 'cd'
      else if (this.userLevelName.toLowerCase() === 'label') imgName = 'label-white'

      return require(`@/assets/icons/${imgName}.svg`)
    },

    creatorUrl() {
      return process.env.VUE_APP_FRONT_URL + 'profile/my-account'
    },
    artistOrLabelUrl() {
      return process.env.VUE_APP_BASE_URL
    },
    youtubeIcon() {
      let svg = 'yt-gray'
      if (this.hasYoutubeChannel) svg = 'yt-red'

      return require(`@/assets/icons/${svg}.svg`)
    },
    hasYoutubeChannel() {
      return this.user.channels.some(el => el.platform === 'youtube')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

#switch-btn {
  display: flex;
  border: 2px solid #E6E5E8;
  margin: 0 24px 20px;
  border-radius: 12px;

  a {
    width: 50%;
    padding: 5px 0;
    color: #0e0525;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;

      img {
        margin-right: 5px;
      }
    }
  }

  .active {
    background: #0E0525;
    color: white;
    border-radius: 10px;
    border: 2px solid #0E0525;
    font-weight: bold;
    font-family: $--font-bold;
  }
}
</style>
